import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import {colors} from './Theme/WebTheme';

export default function AlertDialogTwoButton(props) {
  const { t } = useTranslation();
  const { open,onClose,children,onGoto } = props;
  return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            backgroundColor: 'var(--bg-card)',
            color: 'var(--text-main)',
            border: 'var(--card-border)',
            borderRadius: '16px',
            padding: '8px',
            minWidth: '320px',
            boxShadow: 'var(--shadow-xl)'
          }
        }}
      >
        <DialogTitle id="alert-dialog-title" style={{ color: 'var(--text-main)', fontWeight: 700, fontSize: '1.25rem' }}>
          {t('alert') || "Alert"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ color: 'var(--text-main)', fontSize: '0.95rem', lineHeight: 1.5 }}>
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: '8px 24px 16px 24px' }}>
          <Button 
            onClick={onClose} 
            style={{
              backgroundColor: colors.ALERT_BUTTON_CLOSE_COLOR, 
              color: '#ffffff', 
              padding: '8px 24px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              borderRadius: '9999px'
            }}
          >
            {t('close')}
          </Button>
          <Button 
            onClick={onGoto} 
            style={{
              backgroundColor: colors.ALERT_BUTTON_GOTO_COLOR, 
              color: '#000000', 
              marginLeft: 12,
              padding: '8px 24px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              borderRadius: '9999px'
            }}
          >
            {t('goto')}
          </Button>
        </DialogActions>
      </Dialog>
  );
}

